// MOSAIC — masonry all-visible cards. Q&A cards flow into balanced CSS
// columns (2 columns, 280px minimum) with no toggles. Cards get a staggered
// entrance reveal.
function cardHtml(ctx, it) {
    return `<div class="fq-card"${ctx.reveal(it.idx)}>
  <h3 class="fq-q">${it.q}</h3>
  <div class="fq-a">${it.aHtml}</div>
</div>`;
}
const mosaic = {
    id: 'mosaic',
    name: 'Mosaic',
    tag: 'Masonry cards',
    styleTag: 'All visible',
    description: 'A masonry wall of Q&A cards, no clicking required. Cards flow into balanced columns whatever the answer lengths \u2014 the scannable choice.',
    layout: 'cards',
    defaultAccent: '#0e8f7e',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  <div class="fq-grid">
${ctx.items.map((it) => cardHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:880px;margin:0 auto}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 26px;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-grid{columns:2 280px;column-gap:16px}
.FQM .fq-card{break-inside:avoid;margin-bottom:16px;padding:22px 22px 20px;background:${ctx.v.card};border:1px solid ${ctx.v.border};border-radius:${ctx.v.radiusCard}}
.FQM .fq-q{margin:0 0 8px;font-size:16.5px;font-weight:600;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-a{font-size:14.5px;line-height:1.65;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default mosaic;
